import type { CompanyLicense, CompanySettings } from "@/backend/natsstubs/org_companies/models";
import { plusDays } from "@/utils/date";
import { fromIsoDateString } from "@/utils/dateFormat";

import type { ServerCompanySettings, ServerLicense } from "../serverModel";

/**
 * Legacy `license.get` shape: `expiryDate` is the end of its local day in epoch seconds; the counters and
 * flags pi-web never read (team licenses, sso, external limits) are dropped. An
 * on-prem license carries no plan, which the legacy procedure reported as "".
 */
export function mapApiLicense(license: CompanyLicense): ServerLicense {
  return {
    expiryDate: plusDays(fromIsoDateString(license.expiryDate), 1).getTime() / 1000,
    plan: license.plan ?? "",
    type: license.type,
    tracking: license.tracking,
    onprem: license.onprem,
  };
}

/** The server omits `autoLogoutAfter` when the stored value is null; keep the key absent then. */
export function mapApiCompanySettings(settings: CompanySettings): ServerCompanySettings {
  return settings.autoLogoutAfter === undefined
    ? {}
    : { auto_logout_after: settings.autoLogoutAfter };
}
